<section class="reviews" aria-labelledby="hotel-reviews-heading">
  <div class="reviews__header">
    <h3 id="hotel-reviews-heading" class="reviews__title">{{ 'Common.Reviews' | translate }}</h3>
    <a class="reviews__turpravda-link"
       target="_blank"
       rel="nofollow noopener noreferrer"
       *ngIf="hotel"
       href="https://www.turpravda.ua/">
      <img class="reviews__logo" src="/assets/images/logo_turpravda.svg" [alt]="('Reviews.TourPravda' | translate)!">
    </a>
    <div class="reviews__add-review-btn">
      <button type="button" class="btn btn-primary" (click)="openPostReviewModal()">{{ 'Reviews.AddReview' | translate }}</button>
    </div>
  </div>

  <ng-container *ngIf="ownReviews$ | async as ownReviews">
    <ng-container *ngIf="pagination$ | async as pagination">
      <div class="reviews__body">
        <app-review *ngFor="let review of mixedReviews(ownReviews); trackBy: trackByFn" [review]="review"></app-review>
      </div>
      <p *ngIf="!reviews.length && !ownReviews.length && pagination.empty">{{ 'Reviews.ReviewsNotFound' | translate }}</p>
      <div class="reviews__load-more" *ngIf="pagination.hasNext">
        <button type="button" class="btn btn-outline-dark" [disabled]="!pagination.canLoadMore" (click)="loadNextPage()">
          {{ (pagination.loading && !pagination.canLoadMore ? 'Reviews.Loading' : 'Reviews.LoadMore') | translate }}
        </button>
      </div>
    </ng-container>
  </ng-container>

  <p *ngIf="paginationLimited$ | async">{{ 'Reviews.PaginationLimitReached' | translate }}</p>
  <div *ngIf="error$ | async" class="reviews__source-error">
    <p class="text-danger" role="alert">{{ 'Reviews.SourceTurpravda' | translate }}: {{ 'Reviews.LoadingFailure' | translate }}</p>
    <button type="button" class="btn btn-primary" [disabled]="(isLoading$ | async)!" (click)="retry()">{{ 'Reviews.Retry' | translate }}</button>
  </div>
  <div *ngIf="ownError$ | async" class="reviews__source-error">
    <p class="text-danger" role="alert">{{ 'Reviews.SourceSite' | translate }}: {{ 'Reviews.LoadingFailure' | translate }}</p>
    <button type="button" class="btn btn-primary" [disabled]="(ownLoading$ | async)!" (click)="retryOwn()">{{ 'Reviews.Retry' | translate }}</button>
  </div>
</section>
